import React from 'react';
import { object, string } from 'yup';
import { Formik, Field, Form } from 'formik';
import { TextInput, TextAreaInput, InfoScreenInput } from 'components/FormComponents';
import { urlMessage } from 'utils/validationSchema';

const validationSchema = object().shape({
  gif: string().trim().url(urlMessage),
});

const TextImageForm = (props) => {
  const { onUpdateField, data, footer } = { ...props };

  return (
    <Formik initialValues={data} onSubmit={onUpdateField} validationSchema={validationSchema}>
      {() => (
        <Form className="form">
          <Field type="text" label="Image url" name="gif" component={InfoScreenInput} />
          <Field type="text" label="Título (es)" name="title" component={TextInput} />
          <Field type="text" label="Título (en)" name="en-title" component={TextInput} />
          <Field type="text" label="Contenido (es)" name="content" minRows={10} component={TextAreaInput} />
          <Field type="text" label="Contenido (en)" name="en-content" minRows={10} component={TextAreaInput} />
          {footer}
        </Form>
      )}
    </Formik>
  );
};

export default TextImageForm;
